import React from 'react';
import { ShieldAlert, Clock, Phone, Mail } from 'lucide-react';

const MaintenancePage = () => {
  return (
    <div className="min-h-screen bg-[#0f0f0f] flex items-center justify-center p-4 font-sans">
      <div className="max-w-md w-full bg-[#1a1a1a] border border-white/10 rounded-3xl p-8 shadow-2xl relative overflow-hidden">
        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-32 h-32 bg-primary/10 rounded-full blur-3xl -mr-16 -mt-16"></div>
        <div className="absolute bottom-0 left-0 w-32 h-32 bg-primary/10 rounded-full blur-3xl -ml-16 -mb-16"></div>

        <div className="relative z-10 text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-primary/10 mb-6">
            <ShieldAlert className="w-10 h-10 text-primary" />
          </div>

          <h1 className="text-3xl font-bold text-white mb-2 tracking-tight">
            Acceso Restringido
          </h1>
          <p className="text-gray-400 mb-8">
            El sistema se encuentra temporalmente fuera de servicio por labores de mantenimiento programado o suspensión administrativa.
          </p>

          <div className="space-y-4 mb-8">
            <div className="flex items-center gap-4 p-4 bg-white/5 rounded-2xl border border-white/5">
              <Clock className="w-5 h-5 text-primary" />
              <div className="text-left">
                <p className="text-xs text-gray-500 uppercase font-semibold">Estado</p>
                <p className="text-sm text-white">Suspensión Temporal</p>
              </div>
            </div>
          </div>

          <div className="text-sm text-gray-500 mb-8">
            Para reactivar el servicio, por favor contacte con su proveedor técnico.
          </div>

          <div className="pt-6 border-t border-white/10 flex flex-col gap-3">
             <p className="text-xs text-gray-600">SOPORTE TÉCNICO Z-TACOS</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
